const state = {
  getUserInfo: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js